import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService, Company } from '../../../public-api';
import { SignupDTO, SignupResponseDTO } from '../../models/dto/signup.dto';

@Injectable({ providedIn: 'root' })
export class PublicCompanyService extends AbstractService<Company> {

  getURLBase(): string {
    return '/p/company/';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: Company): void {
    delete obj?._id;
  }
  preUpdate(obj: Company): void {
  }

  signup(dto: SignupDTO): Observable<SignupResponseDTO> {
    return super.post('signup', dto);
  }

}
